import React, { useState } from "react";
import TradingPartnerHistoryModal from "../common/TradingPartnerHistoryModal";
import { Tooltip } from "reactstrap";

type Props = {
  tppId: string;
  status: string;
  spId: string;
  serviceProvider: string;
  submittedBy: string;
  submittedDate: string;
};

export default function StatusCell(props: Props) {
  const [showModal, setShowModal] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggleTooltip = (isOpen: boolean) => setTooltipOpen(isOpen);

  // Tooltip requires a unique target id for accessibility
  const tooltipId = `status-tooltip-${props.tppId}`;

  return (
    <>
      {props.status && (
        <>
          {props.tppId ? (
            <div
              id={tooltipId}
              className="text-primary cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setShowModal(!showModal);
              }}
              onMouseEnter={() => toggleTooltip(true)}
              onMouseLeave={() => toggleTooltip(false)}
            >
              {props.status}
              {props.status.toLowerCase() === "submitted" && props.submittedBy && (
                <Tooltip
                  placement="top"
                  isOpen={tooltipOpen}
                  target={tooltipId}
                  toggle={() => {}}
                  autohide={false}
                >
                  {`Submitted by ${props.submittedBy} on ${props.submittedDate}`}
                </Tooltip>
              )}
            </div>
          ) : (
            <div 
              id={tooltipId}
              onMouseEnter={() => toggleTooltip(true)}
              onMouseLeave={() => toggleTooltip(false)}
            >
              {props.status}
              {props.status.toLowerCase() === "submitted" && props.submittedBy && (
                <Tooltip
                  placement="bottom"
                  isOpen={tooltipOpen}
                  target={tooltipId}
                  toggle={() => {}}
                  autohide={false}
                >
                  {`Submitted by ${props.submittedBy} on ${props.submittedDate}`}
                </Tooltip>
              )}
            </div>
          )}
          {showModal && props.tppId && (
            <TradingPartnerHistoryModal
              closeModal={() => setShowModal(false)}
              tppId={props.tppId}
              spId={props.spId}
              serviceProvider={props.serviceProvider}
            />
          )}
        </>
      )}
    </>
  );
}
 